import React, { useState } from "react";
import { Link } from 'react-router-dom';

interface CookieBannerProps {
  onAcceptRedirectUrl?: string;
}

const CookieBanner: React.FC<CookieBannerProps> = ({ onAcceptRedirectUrl }) => {
  // Estado inicial true para sempre aparecer no refresh
  const [isVisible, setIsVisible] = useState(true);

  const handleAccept = () => {
    setIsVisible(false);
    if (onAcceptRedirectUrl) {
      window.location.href = onAcceptRedirectUrl;
    }
  };

  if (!isVisible) return null;

  return (
    <div id="cookie-overlay">
      <div id="cookie-popup">
        <h3>Cookie Consent</h3>
        <p>
          We use cookies and similar technologies
          to help personalize content, tailor and measure ads,
          and provide a better experience. By clicking accept, 
          you agree to this, as outlined in our Cookie Policy.{" "}
         <Link to="/privacy-policy">Learn more</Link>
        </p>
        <button onClick={handleAccept}>
          Accept
        </button>
      </div>
    </div>
  );
};

export default CookieBanner;